<template>
	<el-dialog v-model="visible" title="日志" v-bind="$attrs" width="50%">
		<div style="margin: 20px auto 0; padding: 0 20px; height: 30vh; overflow: auto" v-loading="loading">
			<template v-if="type == 'text'">
				<div v-html="logData"></div>
			</template>
			<template v-if="type == 'arr'">
				<div class="box" v-for="(item, index) in logData" :key="index">
					{{ item }}
				</div>
			</template>
		</div>
		<template #footer> </template>
	</el-dialog>
</template>
<script>
import { getAction, postAction } from "@/api/manage";
import { ElMessage } from "element-plus";
export default {
	name: "rz-dialog",
	data() {
		return {
			type: "",
			visible: false,
			loading: false,
			logData: null,
		};
	},
	methods: {
		open(options) {
			console.log("rzDialog-open(): options=", options)
			this.type = options.type;
			this.logData = null;
			this.visible = true;
			this.loading = true;
			getAction(options.url, options.params)
				.then((res) => {
					if (res.code == 200) {
						this.logData = res.data;
					} else {
						if(res.message || res.msg)  ElMessage.error(res.message || res.message);
					}
				})
				.finally(() => {
					this.loading = false;
				});
		},
		hide() {
			this.visible = false;
		},
	},
};
</script>
<style scoped>
.box {
	font-size: 14px;
	line-height: 14px;
}
::-webkit-scrollbar {
	width: 5px;
}
::-webkit-scrollbar-thumb {
	background-color: #7da7f0;
}
::-webkit-scrollbar-track {
	background-color: #fff;
}
</style>
